import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { H2, Paragraph, Prose } from '@criteria-labs/react-typography';
import { ParameterList } from '../parameter-list';
import { Section } from '../section';
export function EndpointParametersSection({ endpoint }) {
    const parameters = endpoint.parameters();
    return (_jsxs(Section, { children: [_jsx(Prose, { className: "max-w-none mb-3", children: _jsx(H2, { children: "Parameters" }) }), parameters.length === 0 && (_jsx(Prose, { className: "max-w-none", children: _jsx(Paragraph, { muted: true, children: "No parameters." }) })), parameters.length > 0 && _jsx(ParameterList, { parameters: parameters })] }));
}
